/**
 * Archivo: Avatar.js
 * Fecha: 2026-05-20
 * Descripción: Componente reutilizable de avatar con iniciales y badge
 */

import React from 'react';

const Avatar = ({ nombre, size = 48, badge = null, color = '#1a73e8' }) => {
  const inicial = nombre?.charAt(0)?.toUpperCase() || '?';

  const styles = {
    container: {
      position: 'relative',
      display: 'inline-flex',
    },
    avatar: {
      width: size,
      height: size,
      borderRadius: '50%',
      backgroundColor: color,
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size * 0.4,
      fontWeight: 'bold',
      flexShrink: 0,
    },
    badge: {
      position: 'absolute',
      top: -4,
      right: -4,
      backgroundColor: '#c5221f',
      color: 'white',
      fontSize: Math.max(10, size * 0.25),
      padding: '2px 6px',
      borderRadius: '12px',
      minWidth: size * 0.4,
      textAlign: 'center',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.avatar}>{inicial}</div>
      {badge !== null && badge > 0 && <div style={styles.badge}>{badge}</div>}
    </div>
  );
};

export default Avatar;
